// extracted by mini-css-extract-plugin
export default {"head":"style_head__NPisb"};